var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinilinkedinlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14801",
    "data-name": "Group 14801",
    transform: "translate(-1634 -4341)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(1634 4341)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "linkedin",
    transform: "translate(1635 4340)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14800",
    "data-name": "Group 14800"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14799",
    "data-name": "Group 14799"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_206",
    "data-name": "Ellipse 206",
    cx: 1.379,
    cy: 1.379,
    r: 1.379,
    transform: "translate(9.534 9.534)",
    fill: "#0d4c89"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_960",
    "data-name": "Rectangle 960",
    width: 2.759,
    height: 7.586,
    transform: "translate(9.534 12.905)",
    fill: "#0d4c89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33976",
    "data-name": "Path 33976",
    d: "M237.8,221.091c-2.069,0-2.317,1.228-2.317,1.228v-1.228h-2.759v7.586h2.759v-4.138s0-1.379,1.172-1.379c.69,0,.9.614.9,1.379v4.138h2.759v-4.138C240.314,222.381,239.376,221.091,237.8,221.091Z",
    transform: "translate(-219.144 -208.186)",
    fill: "#0d4c89"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinilinkedinlogo);
export default __webpack_public_path__ + "static/media/minilinkedinlogo.95a548d3473bfc41c9d7718e4bc9cfba.svg";
export { ForwardRef as ReactComponent };